import classNames from 'classnames';
import Typography from 'components/gruenland/atoms/typography';

type Props = {
  label: string;
  children: React.ReactNode;
  className?: string;
};

const OrderData: React.FC<Props> = ({ label, children, className }) => {
  return (
    <div className={classNames('flex flex-col xl:flex-row xl:gap-10', className)}>
      <div className="xl:w-1/4">
        <Typography className="whitespace-nowrap text-[14px] text-secondary-black md:text-[16px]">{label}</Typography>
      </div>
      <div>{children}</div>
    </div>
  );
};

export default OrderData;
